module.exports = __webpack_public_path__ + "static/media/loading.3551210e.gif";